import React, { Component } from "react";
import CreateEmployeeForm from "../CreateEmployeeForm/CreateEmployeeForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : CreateEmployeePage
Description : Componente que contienen el formulario de la pantalla CreateEmployee 
Date Autor Modification
================================================================================
1/10/2021 Santiago Coca Rojas Creación – Se llama al componente CreateEmployeeForm
================================================================================ */
class CreateEmployeePage extends Component{
    render(){
        //console.log("Khe: "+this.props.location.id)
        return(
            <div>                
                <CreateEmployeeForm/>
            </div>
        )   
    }
}

export default CreateEmployeePage;